import { render, staticRenderFns } from "./ChildhoodSyndromesConsentContainer.vue?vue&type=template&id=7dbc7316"
import script from "./ChildhoodSyndromesConsentContainer.vue?vue&type=script&lang=js"
export * from "./ChildhoodSyndromesConsentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports